import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';

import { AuthService } from '../auth/auth.service';

/** Options do request */
export interface IRequestOptions {
    headers?: HttpHeaders;
    observe?: 'body';
    params?: HttpParams;
    reportProgress?: boolean;
    // responseType?: 'arraybuffer'|'blob'|'json'|'text';
    responseType?: any;
    withCredentials?: boolean;
    body?: any;
}

export function customHttpFactory(http: HttpClient, authService: AuthService) {
    return new CustomHttp(http, authService);
}

@Injectable({
    providedIn: 'root'
})
export class CustomHttp {

    constructor(private http: HttpClient,
                private authService: AuthService) { }

    /**
     * GET request
     *
     * @param url end point URL of API
     * @param options options of the request like headers, body, etc.
     * @returns
     */
    public get<T>(url: string, options?: IRequestOptions): Observable<T> {
        return this.http.get<T>(url, options)
                    .pipe(
                        retry(3) // Tentanto executar o request que falhou até 3 vezes antes de retornar erro
                    );
    }

    /**
     * POST request
     *
     * @param url end point URL of API
     * @param body body of the request.
     * @param options options of the request like headers, body, etc.
     * @returns
     */
    public post<T>(url: string, body: Object, options?: IRequestOptions): Observable<T> {
        return this.http.post<T>(url, body, options);
    }

    /**
     * PUT request
     *
     * @param url end point URL of API
     * @param body body of the request.
     * @param options options of the request like headers, body, etc.
     * @returns
     */
    public put<T>(url: string, body: Object, options?: IRequestOptions): Observable<T> {
        return this.http.put<T>(url, body, options)
    }

    /**
     * DELETE request
     *
     * @param url end point URL of API
     * @param options options of the request like headers, body, etc.
     * @returns
     */
    public delete<T>(url: string, options?: IRequestOptions): Observable<T> {
        return this.http.delete<T>(url, options);
    }
}
